<template>
      <div class="login-page">
        <section class="brand-panel">
          <span class="shape shape--1" aria-hidden="true"></span>
          <span class="shape shape--2" aria-hidden="true"></span>
          <span class="shape shape--3" aria-hidden="true"></span>

          <div class="brand-content">
            <img src="@/assets/Logo-depa.png" alt="depa" class="brand-logo"/>
            <h1 class="brand-title">ระบบลงทะเบียนเข้าร่วมประชุม</h1>
            
            <ul class="feature-list">
              <li><v-icon color="secondary">mdi-calendar-plus</v-icon> สร้างและจัดการการประชุม</li>
              <li><v-icon color="secondary">mdi-qrcode-scan</v-icon> QR Code ลงทะเบียนด้วย ThaID</li>
            </ul>
          </div>
        </section>

        <section class="login-panel">
          <div class="login-card">
            <img src="@/assets/logo.png" alt="depa" class="card-logo"/>
            <h2 class="card-title">เข้าสู่ระบบ</h2>
            <p class="card-subtitle">สำหรับเจ้าหน้าที่ depa<br/>ใช้บัญชี Microsoft ขององค์กร (@depa.or.th)</p>
          <!-- <button class="logo-button" @click="LoginToThaID">
            <img src="@/assets/ThaID-logo.png" alt="logothaid" class="logo" style="width: 100%;" />
            <h3 class="text-login">
              LOGIN
            </h3>
          </button> -->
          <button type="button" class="ms-button" @click="LoginToAzure">
            <svg class="ms-logo" viewBox="0 0 21 21" aria-hidden="true">
              <rect x="0" y="0" width="10" height="10" fill="#F25022"/>
              <rect x="11" y="0" width="10" height="10" fill="#7FBA00"/>
              <rect x="0" y="11" width="10" height="10" fill="#00A4EF"/>
              <rect x="11" y="11" width="10" height="10" fill="#FFB900"/>
            </svg>
            <span>เข้าสู่ระบบด้วย Microsoft</span>
          </button>
            <p class="card-help">หากเข้าสู่ระบบไม่ได้ กรุณาติดต่อผู้ดูแลระบบ</p>
          </div>
          <p class="copyright">&copy; {{ year }} Digital Economy Promotion Agency (depa)</p>
        </section>
      </div>
      <!-- <v-flex xs12 sm6 md4 lg3>
          <v-btn  small dark class="primary mr-2" href="https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/?response_type=code&client_id=eWFBN0xZUXZzRjQ4cWFrS2Ezbjk4cDNrTE9xYlZMYVc&redirect_uri=https://dmeeting.depa.or.th/callback/thaid&scope=pid%20name&state=login">Login ThaID</v-btn>

    </v-flex> -->
      <!-- <v-form @submit.prevent="handleSubmit">
        <v-text-field
          v-model="username"
          label="Username"
          required
        ></v-text-field>
        <v-btn type="submit" color="primary">Login</v-btn>
        
      </v-form> -->
      
</template>
  
<!-- <script>
import axios from 'axios';
//   import { mapActions } from 'vuex';
  
  export default {
    name: 'LoginView',
    data() {
      return {
        username: '',
      };
    },
    mounted (){
    let user = localStorage.getItem('user-info');
    if (user){
        this.$router.push('/meeting');      
    }

  },
    methods: {
        async login(){
            const response = await axios.post('http://localhost:3002/login', {
                username: this.username,
            });
            if (response.data.success){
                localStorage.setItem("user-emeeting", JSON.stringify(response.data))
                this.$router.push('/meeting');
            }
            
        }
    //   ...mapActions(['login']), // Map Vuex actions to use in this component
    //   async login() {
    //     try {
    //       const response = await axios.post('http://localhost:3002/login', {
    //         username: this.username,
    //       });
          
  
    //       if (response.data.success) {
    //         this.login(response.data.user); // Commit the user data to Vuex
    //         if (this.$route.path !== '/meeting') {
    //             this.$router.push('/meeting');
    //         }
    //       } else {
    //         alert('Invalid username or password');
    //       }
    //     } catch (error) {
    //       console.error('Login error:', error);
    //       alert('An error occurred during login');
    //     }
    //   },
    },
  };
</script> -->
<script>
import { mapActions } from 'vuex';
import { startAzureLogin } from '@/auth/azure';
import { THAID_REDIRECT_URI } from '@/config';

export default {
  name: 'LoginView',
  data() {
    return {
      username: '',
      year: new Date().getFullYear(),
    };
  },
  methods: {
    ...mapActions(['login']),
    async handleSubmit() {      
        await this.login({ username: this.username });
        this.$router.push('/listmeeting'); 
    },
    LoginToThaID() {
      window.location.href = `https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/?response_type=code&client_id=eWFBN0xZUXZzRjQ4cWFrS2Ezbjk4cDNrTE9xYlZMYVc&redirect_uri=${THAID_REDIRECT_URI}&scope=pid%20name&state=login`;
    },
    LoginToAzure() {
      startAzureLogin();
    },
  },

};
</script>


<style scoped>
.login-page {
  display: flex;
  min-height: 100vh;
  background-color: #F5F7FA;
}

/* ฝั่งซ้าย: แบรนด์ */
.brand-panel {
  position: relative;
  flex: 1 1 55%;
  display: flex;
  align-items: center;
  padding: clamp(40px, 5vw, 72px);
  overflow: hidden;
  background: linear-gradient(135deg, #0C2F53 0%, #123E6B 100%);
}

.brand-content {
  position: relative;
  z-index: 1;
  max-width: 640px;
}

.brand-logo {
  width: clamp(130px, 11vw, 170px);
  height: auto;
  margin-bottom: clamp(24px, 3vw, 40px);
}

/* บรรทัดเดียว: ขนาดตัวอักษรย่อตามความกว้างจอ */
.brand-title {
  color: #FFFFFF;
  font-size: clamp(26px, 2.6vw, 40px);
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 16px;
}

.brand-tagline {
  color: rgba(255, 255, 255, 0.75);
  font-size: clamp(16px, 1.2vw, 18px);
  line-height: 1.6;
  margin-bottom: 32px;
}

.feature-list {
  list-style: none;
  padding: 0 !important;
}

.feature-list li {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #FFFFFF;
  font-size: 17px;
  margin-bottom: 16px;
}

/* รูปทรงตกแต่งสีเหลืองจากโลโก้ depa */
.shape {
  position: absolute;
  display: block;
  pointer-events: none;
}

.shape--1 {
  right: -120px;
  top: -80px;
  width: 420px;
  height: 420px;
  background: linear-gradient(135deg, #FFC600, #FFF200);
  clip-path: polygon(0 0, 100% 45%, 35% 100%);
  opacity: 0.18;
}

.shape--2 {
  right: 60px;
  bottom: -60px;
  width: 260px;
  height: 260px;
  background: linear-gradient(135deg, #FFF200, #FFC600);
  clip-path: polygon(100% 0, 100% 100%, 0 100%);
  opacity: 0.12;
}

.shape--3 {
  left: -80px;
  bottom: 80px;
  width: 180px;
  height: 180px;
  border: 2px solid rgba(255, 198, 0, 0.25);
  border-radius: 50%;
}

/* ฝั่งขวา: การ์ดเข้าสู่ระบบ */
.login-panel {
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.login-card {
  width: 100%;
  max-width: 420px;
  padding: 48px 40px;
  background: #FFFFFF;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(12, 47, 83, 0.12);
  text-align: center;
}

.card-logo {
  width: 120px;
  height: auto;
  margin-bottom: 28px;
}

.card-title {
  color: #0C2F53;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
}

.card-subtitle {
  color: #5B6B7F;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 32px;
}

.card-help {
  color: #8A97A8;
  font-size: 13px;
  margin: 24px 0 0;
}

.copyright {
  color: #8A97A8;
  font-size: 13px;
  margin: 24px 0 0;
}

.ms-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 52px;
  padding: 0 24px;
  background: #FFFFFF;
  border: 1px solid #D0D7E2;
  border-radius: 999px;
  color: #3C3C3C;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(12, 47, 83, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}

.ms-button:hover {
  transform: translateY(-2px);
  border-color: #0C2F53;
  box-shadow: 0 8px 20px rgba(12, 47, 83, 0.16);
}

.ms-button:active {
  transform: translateY(0);
  background: #F3F5F8;
  box-shadow: 0 2px 6px rgba(12, 47, 83, 0.08);
}

/* จอเล็ก: ซ่อนรายละเอียดฝั่งซ้าย เหลือแค่แบรนด์ด้านบน */
@media (max-width: 960px) {
  .login-page {
    flex-direction: column;
  }

  .brand-panel {
    flex: none;
    padding: 36px 24px;
    justify-content: center;
    text-align: center;
  }

  .brand-content {
    max-width: 560px;
  }

  .brand-logo {
    width: 120px;
    margin-bottom: 16px;
  }

  .brand-title {
    font-size: clamp(22px, 5.2vw, 30px);
    margin-bottom: 8px;
  }

  .brand-tagline {
    font-size: 15px;
    margin-bottom: 0;
  }

  /* จอเล็ก: ไม่ใช้รูปทรงตกแต่ง และไม่แสดงโลโก้ซ้ำในการ์ด (มีในแถบด้านบนแล้ว) */
  .feature-list,
  .shape,
  .card-logo {
    display: none;
  }

  .login-panel {
    flex: 1 0 auto;
    padding: 32px 16px;
    justify-content: flex-start;
  }

  .login-card {
    padding: 36px 28px;
  }
}

/* มือถือ */
@media (max-width: 600px) {
  .brand-panel {
    padding: 28px 20px;
  }

  .brand-tagline {
    display: none;
  }

  .login-panel {
    padding: 24px 16px;
  }

  .card-title {
    font-size: 24px;
  }

  .card-subtitle {
    font-size: 14px;
    margin-bottom: 24px;
  }
}

/* มือถือจอเล็ก */
@media (max-width: 380px) {
  .login-card {
    padding: 28px 18px;
    border-radius: 16px;
  }

  .ms-button {
    font-size: 15px;
    padding: 0 16px;
    gap: 10px;
  }
}

/* จอเตี้ย (เช่นมือถือแนวนอน): ไม่บังคับให้เต็มความสูงจอ */
@media (max-height: 560px) and (min-width: 961px) {
  .brand-panel {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  .feature-list {
    display: none;
  }
}

.ms-button:focus-visible {
  outline: 3px solid #00A4EF;
  outline-offset: 3px;
}

.ms-logo {
  width: 21px;
  height: 21px;
  flex-shrink: 0;
}

.logo {
  height: auto;
  margin-bottom: 20px;
}

.logo-button {
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  width: 150px;
}
.text-login {
  color: white;
}
</style>